import HeaderNav from "../navbar/HeaderNav";
function Header() {
  return (
    <>
      <div className="bg-primary">
        <div className="container px-2 md:px-10 m-auto">
          <HeaderNav />
        </div>
      </div>
    </>
  );
}

export default Header;
